import { useTranslation } from '@testsigma/atoms';

export const ImportAndSavePointStatus = ({
  isImporting,
  isSavePointInProgress,
  isSavePointCreationInProgress,
}) => {
  const { t } = useTranslation();

  return (
    <div className='w-full text-error-500 relative flex flex-row items-center justify-center'>
      <span>
        {t('user.imports_banner', {
          entity: isImporting
            ? 'Import'
            : isSavePointInProgress
            ? 'Save point restoration'
            : isSavePointCreationInProgress
            ? 'Creation of Save point'
            : '',
        })}
      </span>
    </div>
  );
};
